import * as React from 'react';
import { ButtonType, CustomButton, CustomSubmitButton, Modal, ModalBody, ModalFooter, ModalSize } from "soprasteria-ui-library";
import { useAuth } from '../../../../App';
import { OrthodonticLkgCfPatientExtensionAdministrationApi } from '../../../../api/OrthodonticLkgCfPatientExtensionAdministrationApi';
import { IOrthodonticLkgCfPatientExtensionDecision } from '../../../../models/IOrthodonticLkgCfPatientExtension';

interface IOrthodonticLkgCfPatientExtensionApproveModal {
    orthodonticLkgCfPatientExtensionId: number;
    getOrthodonticLkgCfPatientExtension: (orthodonticLkgCfPatientExtensionId: number) => void;
    setSuccessMessage: React.Dispatch<React.SetStateAction<string | undefined>>;
}

export const OrthodonticLkgCfPatientExtensionApproveModal: React.FunctionComponent<IOrthodonticLkgCfPatientExtensionApproveModal> = ({ orthodonticLkgCfPatientExtensionId, getOrthodonticLkgCfPatientExtension, setSuccessMessage }) => {

    const auth = useAuth();
    const api = new OrthodonticLkgCfPatientExtensionAdministrationApi(auth);
    const [isApprovingOrthodonticLkgCfPatientExtension, setIsApprovingOrthodonticLkgCfPatientExtension] = React.useState<boolean>(false);

    const approveOrthodonticLkgCfPatientExtension = (data: IOrthodonticLkgCfPatientExtensionDecision) => {
        setIsApprovingOrthodonticLkgCfPatientExtension(true);

        api.approveOrthodonticLkgCfPatientExtension(data.orthodonticLkgCfPatientExtensionId, () => {
            document.getElementById("close-orthodontic-lkgcf-patient-extension-approve-modal")?.click();
            setSuccessMessage("Ansökan har godkänts");
            getOrthodonticLkgCfPatientExtension(orthodonticLkgCfPatientExtensionId);
        }, () => setIsApprovingOrthodonticLkgCfPatientExtension(false));
    }

    return (
        <Modal header="Godkänn ansökan" id="orthodontic-lkgcf-patient-extension-approve-modal" modalSize={ModalSize.normal}>
            <ModalBody>
                <p className="text-left">Är du säker på att du vill godkänna ansökan om förlängning av LKG/CF?</p>
            </ModalBody>
            <ModalFooter>
                <CustomButton buttonType={ButtonType.general} buttonText="Avbryt" data-dismiss="modal" id="close-orthodontic-lkgcf-patient-extension-approve-modal" />
                <CustomSubmitButton onButtonSubmit={approveOrthodonticLkgCfPatientExtension} isLoading={isApprovingOrthodonticLkgCfPatientExtension}>Godkänn</CustomSubmitButton>
            </ModalFooter>
        </Modal>
    )
}